export const LOADING_STARTS = '/ninpath/TopPage/constants/LOADING_STARTS';
export const LOADING_ENDS = '/ninpath/TopPage/constants/LOADING_ENDS';
export const NINPATH_CHECK_LOGGED_IN =
  '/ninpath/TopPage/constants/NINPATH_CHECK_LOGGED_IN';
export const LOGGED_IN = '/ninpath/TopPage/constants/LOGGED_IN';
export const LOGGED_OUT = '/ninpath/TopPage/constants/LOGGED_OUT';
export const RESET_STATE = '/ninpath/TopPage/constants/RESET_STATE';
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
